import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AskCustomerRotateComponent } from "./ask-customer-rotate.component";

@NgModule({
  declarations: [
    AskCustomerRotateComponent
  ],
  imports: [
    CommonModule,
    
  ],
  exports:[
    AskCustomerRotateComponent
  ]
})
export class AskCustomerRotateModule { }
